// src/components/landing/CallToAction.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <section className="bg-[#2196f3] text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-6">
          Ready to Start?
        </h2>
        <p className="text-xl mb-10">
          Join thousands of students improving their study habits
        </p>
        <button
          onClick={handleGetStarted}
          className="inline-flex items-center px-8 py-3 rounded-md bg-green-500 hover:bg-green-600 text-white font-medium transition-colors"
        >
          Get Started Free
          <span className="ml-2">→</span>
        </button>
      </div>
    </section>
  );
};

export default CallToAction;